<template>
  <div class="customer-details">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">客户信息</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="80px">
        <el-form-item label="客户姓名:">
          <el-input v-model="basicInfo.fullName" id="username" clearable></el-input>
          <!--          <el-button round @click="setUserName($event, 'username')">设置</el-button>-->
        </el-form-item>
        <el-form-item label="手机号:">{{ basicInfo.phone }}</el-form-item>
        <el-form-item label="地址:">{{ basicInfo.address === undefined ? '' : basicInfo.address.completeAddress }}</el-form-item>
        <el-form-item label="注册日期:">{{ basicInfo.registerTime }}</el-form-item>
        <el-form-item label="平台号:">{{ basicInfo.store === undefined ? '' : basicInfo.store.code }}</el-form-item>
        <el-form-item label="平台名称:">{{ basicInfo.store === undefined ? '' : basicInfo.store.name }}</el-form-item>
        <el-form-item label="客户类型:">
          <span v-if="basicInfo.userType === 'STORE_ADMIN'">{{ basicInfo.typeName }}</span>
          <el-select clearable v-if="basicInfo.userType !== 'STORE_ADMIN'" v-model="basicInfo.userType" placeholder="请选择" class="customer-select mr-10" style="width: 180px">
            <el-option :label="item.name" :value="item.userType" v-for="(item) in userTypeList" :key="item.userType"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="third-title"><span>收货信息</span></div>
    <div class="task">
      <el-table :data="tableData" border>
        <el-table-column prop="person" label="收货人" min-width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="100"></el-table-column>
        <el-table-column prop="completeAddress" label="地址" min-width="100"></el-table-column>
      </el-table>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="changeUser">保存</el-button>
    </div>
    <!-- 确定弹窗 -->
    <el-dialog :close-on-click-modal="false" title="确定提示" :visible.sync="dialogVisible" width="30%">
      <span>是否保存</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import $ from 'jquery'
import { userQueryByUserId, userGetUserType, userGetUserTypeList, addressGetAddressByUserId, userUpdate } from '@/api/crm'
export default {
  name: 'customer-details',
  data () {
    return {
      dialogVisible: false,
      basicInfo: {},
      showType: true,
      tableData: [{
        taskNum: '20160502',
        skuName: '王大虎',
        proName: '上海市普陀区金沙江路 1518 弄'
      }],
      userTypeList: []
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    userQueryByUserId(this.$route.query.id).then((res) => {
      if (res.data.success) {
        this.basicInfo = res.data.data
        this.basicInfo.phone = this.$msg.filterBridal(res.data.data.phone)
      }
    })
    userGetUserTypeList(1).then((res) => {
      if (res.data.success) {
        // this.userTypeList = res.data.data.filter(val => val.userType !== 'STORE_SUBADMIN')
        this.userTypeList = res.data.data
      }
    })
    addressGetAddressByUserId(this.$route.query.id).then((res) => {
      if (res.data.success) {
        this.tableData = res.data.data.map(a => {
          if (a.phone) {
            a.phone = this.$msg.filterBridal(a.phone)
          }
          return a
        })
      }
    })
  },
  methods: {
    changeUser () {
      this.dialogVisible = true
    },
    confirm () {
      let { fullName, id, userType } = this.basicInfo
      userUpdate({ fullName, id, userType }).then(res => {
        if (res.data.success) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.dialogVisible = false
          this.$router.push({
            path: '/customerinfo'
          })
        } else {
          this.$message({
            message: '修改失败',
            type: 'error'
          })
        }
      })
      // this.dialogVisible = false
    }
  }
}
</script>
<style scoped lang="less">
@import "index.less";
@deep: ~">>>";
</style>
